import {
  BooleanFilterSection,
  DiscountLevelFilter as DiscountLevelFilterType,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';

export const useDiscountFilterSection = ({
  data,
  activeFilters,
  setFilter,
  onApplyDiscount,
}: {
  data: DiscountLevelFilterType;
  activeFilters: Map<string, Array<string> | undefined>;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  onApplyDiscount?: (filterType: string) => void;
}) => {
  const {discountLevels} = data;

  const {
    label: discountLevelFilterLabel,
    slug: discountLevelFilterSlug,
    value: discountFilterValue,
  } = getFilterData({activeFilters, filter: data});

  const discountLevelOptions = discountLevels.map(discountLevel => ({
    id: `${discountLevel.value}`,
    label: discountLevel.label,
  }));
  const activeDiscountFilterValue = discountFilterValue?.[0];

  const handleApplyDiscount = (id: string) => {
    onApplyDiscount && onApplyDiscount(data.slug);
    setFilter({
      filterId: id,
      filterSection: discountLevelFilterSlug!,
      singleSelectOnly: true,
    });
  };

  return {
    discountLevelFilterLabel,
    discountLevelFilterSlug,
    activeDiscountFilterValue,
    discountLevelOptions,
    handleApplyDiscount,
    hasAppliedDiscount: Boolean(activeDiscountFilterValue),
  };
};

const getFilterData = ({
  activeFilters,
  filter,
}: {
  activeFilters: Map<string, Array<string> | undefined>;
  filter?: DiscountLevelFilterType | BooleanFilterSection;
}) => {
  if (!filter) {
    return {
      active: false,
      label: undefined,
      slug: undefined,
    };
  }

  const label = filter.label;
  const slug = filter.slug;
  const value = activeFilters.get(slug);

  return {
    label,
    slug,
    value,
  };
};
